/*
 * Purpose : Brokers config Landing page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React,{ useState, useEffect } from 'react';
import {FaCheckCircle} from "react-icons/fa";
import {TiUserAddOutline} from "react-icons/ti"
import {AiFillCloseCircle} from "react-icons/ai"
import ReactTable from 'react-table';
import { Button, Alert, Modal, ModalBody, ModalHeader, Row, Col } from 'reactstrap'
import axios from 'axios';
import uniqid from 'uniqid';

import "./BrokerConfig.css";
import Aux from '../../../hoc/Auxilliary/Auxilliary';
import {brokerTableHeaders} from '../../../config/constants';
import BrokerForm from '../../../components/brokers/AddEditBrokers';
import LoadingModal from '../../../components/UI/modals/loadingModal';
//amplify
import { API, graphqlOperation } from 'aws-amplify';
import ToolSalesButton from '../../../components/UI/Buttons/ToolSalesButton/ToolSalesButton';
import BackButton from '../../../components/UI/Buttons/BackButton/BackButton';
import DeleteAlertModal from '../../../components/UI/modals/DeleteAlertModal';



const BrokerConfig = () => {
    //console.log("UserManagement Component imported")
    const [loading, setLoading] = useState(false)
    const [modal, setModal] = useState(false);
    const [stateValues, setStateValues] = useState({});
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)
    const [deleteModal, setDeleteModal] = useState(false)
    const [row, setRow] = useState({})
    const [data, setData] = useState([])
    const [columns, setColumns] = useState([])

    const toggleModal = () => setModal(!modal);

    const getBrokers = async() => {
        const q = `query 
                {listExcessbrokerconfigs(limit:${process.env.REACT_APP_BROKER_TABLE_LIMIT}){
                    items{
                        id
                        broker
                        enable
                    }
                }}`;
            const apiData =await API.graphql(graphqlOperation(q))
            //console.log("apiData==>",apiData)
            const results = apiData.data.listExcessbrokerconfigs.items;
            //console.log("results==>",results)
            const data = results.map(e => {
                const rec = { ...e }
                rec.actions = buildActions(e)
                return rec
            })
            console.log("data fetched")
            return data
    }
   
    const submithandler = async (id,broker,enableFlag,action) => {        
        let brokerRecord = {
            id: id?id:uniqid.time(),
            broker: broker,
            enable: enableFlag?"Yes":"No"            
        }
        //brokerRecord = JSON.stringify(brokerRecord)
        //console.log("brokerRecord=>",brokerRecord)
        const createMutation = `mutation {
            createExcessbrokerconfig(input: {id: "${brokerRecord.id}", broker:"${brokerRecord.broker}", enable:"${brokerRecord.enable}" }) {
                broker
                id
            }
        }`
        const updateMutation = `mutation {
            updateExcessbrokerconfig(input: {id: "${brokerRecord.id}", broker:"${brokerRecord.broker}", enable:"${brokerRecord.enable}" }) {
                broker
                id
            }
        }`
        await API.graphql(graphqlOperation(action ==='add' ? createMutation:updateMutation))
        .then(async result =>
            {
                //console.log("result broker create ==>",result)
                setModal(false)
                if(action==="add"){
                    setSuccess("Broker was added successfully.!")
                }
                else{
                    setSuccess("Broker was updated successfully.!")
                }
                const data = await getBrokers()
                //console.log("data 2 =>",data)
                setData(data)
            }
        ).catch(error => {
            console.log("error create broker ==>",error.errors && error.errors[0].errorType)
            console.log("err while processing broker submit=>", JSON.stringify(error, null, 4))
            const reqBody = {
                level:"error",
                message: "Error while processing broker submit. error: "+JSON.stringify(error, null, 4)
            }
            axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                            reqBody,
                            { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
                        );
            
            setModal(false)
            if(error.errors && error.errors[0].errorType.indexOf("ConditionalCheckFailedException") !== -1)
            {
                setError("Duplicate record found.! Please check and try again.!")
            }
            else{
                setError("There is some error.! Please try again.!")
            }
        });
    }
    
    const addFormHandler = () =>{
        setStateValues({
            id:"",
            broker:"",
            enable:"",
            action:"add"
        })
        setModal(true)
    }
    
    const editFormHandler = (editRow) =>{
        //console.log("row->",editRow)
        editRow.action="edit"
        setStateValues(editRow)
        setModal(true)
    }
    const confirmDelete = (row) => {
        setRow(row)
        setDeleteModal(true)
    }
    const deleteHandler = async (row) => {
        //console.log("row=>",row);
        setLoading(true)
        setDeleteModal(false)
        const q = `mutation {
                    deleteExcessbrokerconfig(input: {id: "${row.id}" }) {
                        broker
                        id
                }
            }`
        //console.log("q=>",q)
        const apiData =await API.graphql(graphqlOperation(q))
        //console.log("apiData=>",apiData.data.deleteExcessuserroles)
        setLoading(false)
        if(apiData.data.deleteExcessbrokerconfig && apiData.data.deleteExcessbrokerconfig!=null)
        {
            setSuccess(`Broker : ${apiData.data.deleteExcessbrokerconfig.broker} was removed successfully.!`)
            const data = await getBrokers()
            //console.log("data 3 =>",data)
            setData(data)
        }
        else{
            console.log("err while deleting broker=>", error)
            const reqBody = {
                level:"error",
                message: "Error while deleting broker. error: "+error
            }
            axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                            reqBody,
                            { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
                        );
            setError("Error while deleting the record.! Please try again.!")
            
        }
    }

    const buildActions = (tableRow) => {
        const actions = [];
        //console.log("tableRow=>",tableRow)
        actions.push(
            <div key={tableRow.id} className={"actionDivBroker"}>
                <Button className={"editBtnLoc"} color="warning" onClick={() => editFormHandler(tableRow) }>Edit{'  '}</Button>
                <Button className={"delBtnLoc"} color="danger" onClick={() => confirmDelete(tableRow)}>Delete</Button>
                {/* <div className={"mobileView"}>
                <Button key={"edit"}  outline size="sm" color="warning" onClick={() => editFormHandler(tableRow)} alt="Edit"><MdEdit /></Button>
                </div> */}
            </div>
        )
        return <div style={{width:"100%", textAlign:"center"}} key={"actions"} >{actions}</div>
    }
    
    useEffect( () => {
        setLoading(true)
        const buildData = async () => {
            // set Table Headers
            const columns = []
            Object.keys(brokerTableHeaders).forEach((col, i) => {
                if (col.toLowerCase() === "actions") {
                    columns.push({
                        Header:brokerTableHeaders[col],
                        accessor:col,
                        filterable:false,
                    })
                }
                else if(col==="enable"){
                    columns.push({
                        Header:brokerTableHeaders[col],
                        accessor:col,
                        filterable:true,
                        Cell: e=> {
                            if(e.value==="Yes")
                                return <div style={{textAlign:"center"}}><FaCheckCircle color="green"/></div>
                            else
                                return <div style={{textAlign:"center"}}><AiFillCloseCircle color="red"/></div>
                        }
                    })
                }
                else{
                    columns.push({
                        Header:brokerTableHeaders[col],
                        accessor:col,
                        filterable:true,
                    })
                }
            });
            setColumns(columns);
            const data = await getBrokers()            
            // console.log("columns=>",columns)
            //console.log("data=>",data)
            setData(data)
            setLoading(false)
        }
        buildData()
    }, [] );

    return (
        <Aux>
            <Alert color="danger" isOpen={error!=null?true:false}>{error}</Alert>                    
            <Alert color="success" isOpen={success!=null?true:false}>{success}</Alert>                    
            <Modal isOpen={modal} toggle={toggleModal} size="lg" draggable={false} centered={true}>
                <ModalHeader>Add/Edit Broker</ModalHeader>
                <ModalBody>
                    <BrokerForm submithandler={submithandler} stateVals={stateValues} closeHandler={toggleModal}/>
                </ModalBody>
            </Modal>
            {/* <Modal isOpen={deleteModal} toggle={()=>setDeleteModal(false)}>
                <ModalHeader><font color="#ffc107">Delete Confirmation!</font></ModalHeader>
                <ModalBody>
                    <p>Are you sure you want to delete this record? You will not be able to undo this action.</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary"
                            style={{backgroundColor:"#fb8734", borderColor:"#fff", boxShadow:"0px 1px 2px 2px #C0C0C0"}} onClick={()=> deleteHandler(row)}>Delete</Button>{' '}
                    <Button color="secondary" onClick={()=>setDeleteModal(false)}>Cancel</Button>    
                </ModalFooter>
            </Modal> */}
            <DeleteAlertModal open={deleteModal} handler={setDeleteModal} deleteHandler={deleteHandler.bind(this,row)}/>
            <LoadingModal open={loading} msg="Loading..." />            
            <div className="topBtnDivSetup">
                <Row form style={{ justifyContent: "flex-end" }}>
                    <Col md="auto">
                        <ToolSalesButton onClick={addFormHandler} >
                            <TiUserAddOutline style={{fontSize:"20px"}} />&nbsp;&nbsp;Add Broker
                        </ToolSalesButton>
                    </Col>
                    <Col md="auto">
                        <BackButton path="/setup" label="Go Back"/>
                    </Col>
                </Row>
            </div>  
            { data.length !== 0 ? 
                <div style={ {margin: "0% 2%", width: "-webkit-fill-available !important" } }>                           
                    <ReactTable data={data} columns={columns} defaultPageSize={10} />
                </div>
                : <div className={"noDataDiv"}><p>No data Found.!</p></div> }                    
        </Aux>
    )
}
export default BrokerConfig;